// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReceiptContainer-root-A8oe4 {
  padding-left: 20px;
  padding-right: 20px;
}

.ReceiptContainer-container-B7o2f {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-content-width);
}`, "",{"version":3,"sources":["webpack://./src/routes/receipt/ReceiptContainer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-content-width);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ReceiptContainer-root-A8oe4`,
	"container": `ReceiptContainer-container-B7o2f`
};
module.exports = ___CSS_LOADER_EXPORT___;
